try{(function(){var d=new Date(),n=0;while(n<3){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n++;}
var m=['January','February','March','April','May','June','July','August','September','October','November','December'];
var s=d.getDate(),suf=(s%10==1&&s!=11)?'st':(s%10==2&&s!=12)?'nd':(s%10==3&&s!=13)?'rd':'th';
var el=document.getElementById('sl-deldate');if(el)el.textContent=d.toLocaleDateString('en-GB',{weekday:'long'})+' '+s+suf+' '+m[d.getMonth()];})();}catch(e){console.error(e)}
try{(function(){function mv(){var u=document.getElementById('sl-um'),w=document.querySelector('.product__media-wrapper');if(!u||!w)return;
if(window.innerWidth>=990){if(u.parentNode!==w)w.appendChild(u);}}mv();window.addEventListener('resize',mv);})();}catch(e){console.error(e)}
try{
(function(){
var hk='selResultsScroll';if(window[hk])document.removeEventListener('click',window[hk]);
window[hk]=function(e){if(!(e.target instanceof Element))return;var b=e.target.closest('[data-sel-scroll-offer]');if(!b)return;e.preventDefault();
var t=document.querySelector('kaching-bundle')||document.querySelector('.product__info-wrapper')||document.querySelector('form[action*="/cart/add"]');
var off=20;document.querySelectorAll('header,sticky-header,.shopify-section-header').forEach(function(h){var p=getComputedStyle(h).position,r=h.getBoundingClientRect();if((p==='fixed'||p==='sticky')&&r.top<=160&&r.bottom>0&&r.height<300)off=Math.max(off,r.bottom+20);});
var top=t?t.getBoundingClientRect().top+window.scrollY-off:0;
window.scrollTo({top:Math.max(0,top),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
document.addEventListener('click',window[hk]);
})();
(function(){
var key='selResultsCount';
if(!window[key]){
var done=new WeakSet(),dur=1600,rm=matchMedia('(prefers-reduced-motion: reduce)');
function fmt(n,el){return Math.round(n).toLocaleString('en-GB')+(el.dataset.selSuffix||'');}
function fin(el){el.textContent=fmt(Number(el.dataset.selCount),el);}
function anim(el){var tgt=Number(el.dataset.selCount),s=null;function f(now){if(!el.isConnected)return;if(rm.matches){fin(el);return;}if(s===null)s=now;var p=Math.min((now-s)/dur,1);el.textContent=fmt(tgt*(1-Math.pow(1-p,3)),el);if(p<1)requestAnimationFrame(f);else fin(el);}requestAnimationFrame(f);}
var ob='IntersectionObserver' in window?new IntersectionObserver(function(es){es.forEach(function(en){if(!en.isIntersecting||en.intersectionRatio<.35)return;ob.unobserve(en.target);anim(en.target);});},{threshold:.35,rootMargin:'0px 0px -24px 0px'}):null;
function init(root){root.querySelectorAll('.sel-results [data-sel-count]').forEach(function(el){if(done.has(el))return;done.add(el);if(!ob||rm.matches){fin(el);return;}el.textContent=fmt(0,el);ob.observe(el);});}
window[key]={init:init};
document.addEventListener('shopify:section:load',function(e){init(e.target);});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
}
window[key].init(document);
})();
}catch(e){console.error(e)}
try{
(function () {
if (window.eloriaFiveReasons) {
window.eloriaFiveReasons.init(document);
return;
}
var instances = new Map();
var reducedMotion = window.matchMedia(
'(prefers-reduced-motion: reduce)'
);
function scrollToOffer(button) {
var buttonTop =
button.getBoundingClientRect().top + window.scrollY;
function above(nodes) {
return Array.from(nodes).find(function (node) {
return (
node.getClientRects().length &&
window.getComputedStyle(node).visibility !== 'hidden' &&
!node.closest(
'dialog, [role="dialog"], quick-add-modal, ' +
'cart-drawer, .cart-drawer, sticky-add-to-cart, ' +
'.sticky-add-to-cart, .sticky-atc, ' +
'[data-sticky-add-to-cart]'
) &&
node.getBoundingClientRect().top + window.scrollY <
buttonTop
);
});
}
var target = above(
document.querySelectorAll(
'#eloria-offer, [data-eloria-offer], [data-product-offer]'
)
);
if (!target) {
var main = document.querySelector('main') || document;
var form = above(
main.querySelectorAll('form[action*="/cart/add"]')
);
if (form) {
var info = form.closest(
'product-info, .product__info-container, ' +
'.product-info, [data-product-info], ' +
'.product__info-wrapper'
);
target = info && above(
info.querySelectorAll(
'kaching-bundles, .kaching-bundles, ' +
'quantity-breaks, [data-bundle-offer]'
)
);
target = target || info || form;
}
}
var offset = 20;
document.querySelectorAll(
'header, sticky-header, [data-sticky-header], ' +
'.shopify-section-header'
).forEach(function (header) {
var position = window.getComputedStyle(header).position;
var rect = header.getBoundingClientRect();
if (
(position === 'fixed' || position === 'sticky') &&
rect.top <= 160 &&
rect.bottom > 0 &&
rect.height < 300
) {
offset = Math.max(offset, rect.bottom + 20);
}
});
var top = target
? target.getBoundingClientRect().top + window.scrollY - offset
: 0;
window.scrollTo({
top: Math.max(0, Math.min(window.scrollY, top)),
behavior: reducedMotion.matches ? 'instant' : 'smooth'
});
}
function setup(section) {
if (instances.has(section)) return;
var viewport = section.querySelector('[data-reasons-viewport]');
var cards = Array.from(
section.querySelectorAll('[data-reason-card]')
);
var dots = section.querySelector('[data-reasons-dots]');
var previous = section.querySelector('[data-reasons-prev]');
var next = section.querySelector('[data-reasons-next]');
var status = section.querySelector('[data-reasons-status]');
var columns = 3;
var current = 0;
var max = 2;
var step = 1;
var frame = 0;
function select(index) {
cards.forEach(function (card, i) {
card.classList.toggle('is-selected', i === index);
card.querySelector('[data-reason-select]').setAttribute(
'aria-pressed',
String(i === index)
);
});
}
function sync() {
current = Math.max(
0,
Math.min(max, Math.round(viewport.scrollLeft / step))
);
previous.disabled = current === 0;
next.disabled = current === max;
Array.from(dots.children).forEach(function (dot, i) {
if (i === current) {
dot.setAttribute('aria-current', 'true');
} else {
dot.removeAttribute('aria-current');
}
});
status.textContent =
'Showing reasons ' + (current + 1) +
' to ' + Math.min(cards.length, current + columns) +
' of ' + cards.length;
}
function go(index, instant) {
var destination = Math.max(0, Math.min(max, index));
select(destination + Math.floor(columns / 2));
viewport.scrollTo({
left: destination * step,
behavior:
instant || reducedMotion.matches ? 'instant' : 'smooth'
});
if (instant || reducedMotion.matches) sync();
}
function measure() {
var oldCurrent = current;
var styles = window.getComputedStyle(viewport);
columns = Math.max(
1,
Math.min(
cards.length,
parseInt(styles.getPropertyValue('--er-columns'), 10) || 1
)
);
step =
cards[0].getBoundingClientRect().width +
(parseFloat(styles.getPropertyValue('--er-gap')) || 0);
if (!step) return;
max = cards.length - columns;
if (dots.children.length !== max + 1) {
dots.replaceChildren();
for (var i = 0; i <= max; i++) {
var dot = document.createElement('button');
dot.type = 'button';
dot.className = 'eloria-reasons__dot';
dot.dataset.reasonsIndex = String(i);
dot.setAttribute(
'aria-label',
'Show reasons ' + (i + 1) + ' to ' + (i + columns)
);
dots.appendChild(dot);
}
}
go(Math.min(oldCurrent, max), true);
}
function onScroll() {
if (frame) return;
frame = window.requestAnimationFrame(function () {
frame = 0;
var before = current;
sync();
if (before !== current) {
select(current + Math.floor(columns / 2));
}
});
}
function onClick(event) {
var control = event.target.closest(
'button, [data-reasons-offer]'
);
if (!control || !section.contains(control)) return;
if (control.matches('[data-reasons-prev]')) {
go(current - 1);
} else if (control.matches('[data-reasons-next]')) {
go(current + 1);
} else if (control.hasAttribute('data-reasons-index')) {
go(Number(control.dataset.reasonsIndex));
} else if (control.matches('[data-reason-select]')) {
select(
cards.indexOf(control.closest('[data-reason-card]'))
);
} else if (control.matches('[data-reasons-offer]')) {
event.preventDefault();
scrollToOffer(control);
}
}
function onKey(event) {
if (
!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
) {
return;
}
event.preventDefault();
go(
event.key === 'Home'
? 0
: event.key === 'End'
? max
: current + (event.key === 'ArrowRight' ? 1 : -1)
);
}
section.addEventListener('click', onClick);
viewport.addEventListener('scroll', onScroll, { passive: true });
viewport.addEventListener('keydown', onKey);
section.querySelector('[data-reasons-controls]').hidden = false;
section.classList.add('is-ready');
var observer = 'ResizeObserver' in window
? new ResizeObserver(measure)
: null;
if (observer) {
observer.observe(viewport);
} else {
window.addEventListener('resize', measure);
}
measure();
instances.set(section, function () {
section.removeEventListener('click', onClick);
viewport.removeEventListener('scroll', onScroll);
viewport.removeEventListener('keydown', onKey);
if (observer) {
observer.disconnect();
} else {
window.removeEventListener('resize', measure);
}
if (frame) window.cancelAnimationFrame(frame);
instances.delete(section);
});
}
function init(root) {
if (root.matches && root.matches('[data-eloria-reasons]')) {
setup(root);
}
root.querySelectorAll('[data-eloria-reasons]').forEach(setup);
}
window.eloriaFiveReasons = { init: init };
init(document);
document.addEventListener(
'DOMContentLoaded',
function () {
init(document);
},
{ once: true }
);
document.addEventListener('shopify:section:load', function (event) {
init(event.target);
});
document.addEventListener('shopify:section:unload', function (event) {
instances.forEach(function (cleanup, section) {
if (
event.target === section ||
event.target.contains(section)
) {
cleanup();
}
});
});
})();
}catch(e){console.error(e)}
try{(function(){
function init(root){root.querySelectorAll('[data-wj]').forEach(function(sec){if(sec.dataset.ready)return;sec.dataset.ready=1;
var tl=sec.querySelector('[data-tl]'),fil=sec.querySelector('[data-fil]'),st=[].slice.call(sec.querySelectorAll('[data-st]')),tick=false;
function upd(){tick=false;var vh=window.innerHeight,mark=vh*0.6,r=tl.getBoundingClientRect(),top=12,max=r.height-24;
var p=Math.max(0,Math.min(max,mark-r.top-top));fil.style.height=p+'px';var cur=-1;
st.forEach(function(s,i){var d=s.querySelector('.dot').getBoundingClientRect();var on=d.top+8<mark;s.classList.toggle('on',on);if(on)cur=i;});
st.forEach(function(s,i){s.classList.toggle('cur',i===cur);});}
function req(){if(!tick){tick=true;requestAnimationFrame(upd);}}
window.addEventListener('scroll',req,{passive:true});window.addEventListener('resize',req);upd();});}
init(document);document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();}catch(e){console.error(e)}
try{(function(){var d=new Date(),n=0;while(n<3){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n++;}var m=['January','February','March','April','May','June','July','August','September','October','November','December'];var s=d.getDate(),x=(s%10==1&&s!=11)?'st':(s%10==2&&s!=12)?'nd':(s%10==3&&s!=13)?'rd':'th';document.querySelectorAll('.sl-deldate2').forEach(function(e){e.textContent=m[d.getMonth()]+' '+s+x;});})();}catch(e){console.error(e)}
try{(function(){
function setup(s){if(s.dataset.ready)return;s.dataset.ready=1;
var tr=s.querySelector('[data-tr]'),dots=s.querySelector('[data-dots]'),n=tr.children.length,cur=0,busy=false;
[].forEach.call(tr.children,function(c,i){c.dataset.i=i;var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Review '+(i+1));b.onclick=function(){go(i);};dots.appendChild(b);});
function step(){var c=tr.children[0];return c.getBoundingClientRect().width+16;}
function mark(){[].forEach.call(dots.children,function(d,i){d.classList.toggle('on',i===cur);});}
function next(){if(busy)return;busy=true;tr.style.transition='';tr.style.transform='translateX(-'+step()+'px)';
setTimeout(function(){tr.style.transition='none';tr.appendChild(tr.children[0]);tr.style.transform='translateX(0)';void tr.offsetWidth;tr.style.transition='';cur=(cur+1)%n;mark();busy=false;},460);}
function prev(){if(busy)return;busy=true;tr.style.transition='none';tr.insertBefore(tr.lastElementChild,tr.firstElementChild);tr.style.transform='translateX(-'+step()+'px)';void tr.offsetWidth;tr.style.transition='';tr.style.transform='translateX(0)';
setTimeout(function(){cur=(cur-1+n)%n;mark();busy=false;},460);}
function go(i){var d=(i-cur+n)%n;if(!d)return;var k=0;(function loop(){if(k++<d){next();setTimeout(loop,480);}})();}
s.querySelector('[data-next]').onclick=next;s.querySelector('[data-prev]').onclick=prev;mark();}
function init(r){r.querySelectorAll('[data-rv2]').forEach(setup);}init(document);document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();}catch(e){console.error(e)}